exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n * styles.css\n * Copyright (C) 2018 rgregoir\n *\n * Distributed under terms of the MIT license.\n */\n\n.DropZone {\n  border: 3px dashed #888;\n  border-radius: 4px;\n  color: #aaa;\n  text-align: center;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 2em;\n  cursor: pointer;\n}\n.DropZone:hover {\n  background-color: rgba(0, 0, 0, 0.025);\n}\n.DropZone:focus,\n.DropZone--over-document {\n  border: 3px dashed #599eff;\n}\n.DropZone--over {\n  border: 3px dashed #259925;\n}\n", ""]);

// exports
